import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFilterAccordionItem } from '#/modules/search/components/Filter/AccordionItem/SearchFilterAccordionItem';
import { SearchFilterToggleButton } from '#/modules/search/components/Filter/ToggleButton/SearchFilterToggleButton';
import { useSearchFilterSelectedValue } from '#/modules/search/hooks/filters/useSearchFilterSelectedValue';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';

type Props = {
  variant: SearchRefinementVariant;
};

export function IdealistDaysFilter({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValue = useSearchFilterSelectedValue('isIdealistDay');

  const FilterVariant =
    variant === 'accordion'
      ? SearchFilterAccordionItem
      : SearchFilterToggleButton;

  return (
    <FilterVariant
      facetType="isIdealistDay"
      initialValue={selectedFacetValue}
      icon="idealist-logo"
      label={<>{i18n('Show only Idealist Days')} </>}
    />
  );
}
